// Function attempting to split string in half, using ';' or ',' as a separator
// For example
// Input: "20, Flat 1, 40 Offerton Road, London" =>
// Output:
// - 20, Flat 1
// - 40 Offerton Road, London
const halveText = text => {
  const middle = Math.floor(text.length / 2)
  let divider = -1

  const semicolonPosition = text.indexOf(";")
  const semicolonCloseToMiddle =
    Math.abs(middle - semicolonPosition) / middle < 0.5

  if (semicolonCloseToMiddle) {
    divider = semicolonPosition
  } else {
    const before = text.lastIndexOf(",", middle)
    const after = text.indexOf(",", middle + 1)

    if (after === -1 || (middle - before < after - middle && before !== -1)) {
      divider = before
    } else {
      divider = after
    }

    const dividerFarFromMiddle = Math.abs(middle - divider) / middle > 0.5

    if (dividerFarFromMiddle) {
      return text
    }
  }
  return [text.substr(0, divider), text.substr(divider + 1)].join("\n")
}

const capitalize = text => text.replace(/\b\w/g, char => char.toUpperCase())

export const getAddressFromFormData = ({
  postcode,
  firstLine,
  secondLine,
  address: addressObject
}) => {
  let address = null
  if (addressObject && addressObject.address) {
    address = addressObject.address.toLowerCase()
    address = capitalize(address)
    address = halveText(address)
  } else if (firstLine) {
    address = firstLine
    if (secondLine) {
      address += `\n${secondLine}`
    }
  } else {
    return null
  }

  return `${address}\n${postcode.toUpperCase()}`
}

// takes duration in months that (must be a modulo of 12) and converts it into years
export const durationInYears = durationMonths =>
  ["One", "Two", "Three", "Four", "Five", "Six"][
    Math.trunc(durationMonths / 12) - 1
  ]
